/* eslint-disable react/no-unused-class-component-methods */
'use strict';

import React, { Component } from 'react'

import _ from 'lodash'

import Layout from '@Layout/BackOffice'

import CheckboxEl from '@/Form/V2/Managed/CheckboxEl'
import Dashboard  from '@/Lists/Dashboard'
import ECRow      from '@/Lists/Rows/ECRow'

import FormElement from '@/Form/toolkit/FormElement'

import _config from '@Config/EC/EC'

import SearchBar from '@Pure/SearchBar'
import Link      from '@Pure/Link'

import { isTrue } from '@root/utility'

const config = _.cloneDeep(_config);

let app = window.app;

const header = Object.keys(config.header_map).map(function (label)
{
	const name = config.header_map[label];

	const item =
	{
		label: label,
		name: name,
		sortable: (config.sortable_columns || []).includes(name)
	};

	return item;
});

const fields = header.map(data => data.name);

const fields_with_timeout = ['searched'];

export default class ECsPage extends Component
{
	state =
	{
		searched: window.localStorage.getItem('ECsList.searched') || '',
		delayed_searched: window.localStorage.getItem('ECsList.searched') || '',

		enabled: !window.localStorage.getItem('ECsList.enabled')
		? true
		: isTrue(window.localStorage.getItem('ECsList.enabled')),

		renewed_only: isTrue(window.localStorage.getItem('ECsList.renewed_only')),

		renewed_budget_changed: window.localStorage
		.getItem('ECsList.renewed_budget_changed') || '',

		status_messages: { }
	};

	UNSAFE_componentWillMount ()
	{
		app.resetFunctions();
	}

	handleSearchChange = (value, data={ }, e) =>
	{
		const component = this, props = this.props, state = this.state;

		component.handleChange({ value: value, name: data?.name, e });
	}

	handleChange = ({ value, name, e }) =>
	{
		const component = this, props = this.props, state = this.state;

		window.localStorage.setItem('ECsList.' + name, value);

	// Prevent on mount trigger
		if (e === null && fields_with_timeout.includes(name)) return;

		component.setState({ [name]: value });

		if (fields_with_timeout.includes(name) === false) return;

		if (component.search_timeout)
		{
			window.clearTimeout(component.search_timeout);
		}

		component.search_timeout = window.setTimeout(function ()
		{
			component.search_timeout = undefined;

			component.setState({ ['delayed_' + name]: value });
		},
		320);
	}

	handleFormElementChange = (e, data={ }) =>
	{
		const component = this, props = this.props, state = this.state;

		if (e === null) return;

		component.handleChange({ value: data?.value, name: data?.name, e });
	}

	handleSwitchChange = (e, name) =>
	{
		const component = this, props = this.props, state = this.state;

		if (e === null) return;

		component.handleChange(
		{
			value: !isTrue(state[name]), name: name, e
		});
	}

	render ()
	{
		const component = this, props = this.props, state = this.state;

		const filters =
		{
			searched: state.delayed_searched,

			enabled: isTrue(state.enabled),
			renewed_only: isTrue(state.renewed_only),
			renewed_budget_changed: isTrue(state.renewed_budget_changed)
		};

		var output =
		(
			<Layout history={ props.history } page_title="Liste des CE">

				<div className="page-content">

					<div className="o-grid-5 u-content-between u-items-center
						u-margin-bottom-30">

						<div className="o-grid__item">
							<SearchBar hide_btn={ true } placeholder="Recherche..."
								handleChange={ component.handleSearchChange }
								value={ state.searched }
								name="searched"
							/>
						</div>

						<div className="o-grid__item">
							<CheckboxEl name="enabled"
								checked={ isTrue(state.enabled) }
								onChange={ component.handleSwitchChange }
								left-label="Désactivés"
								label="Activés"
								bemit={ ['switch'] }
							/>
						</div>

						<div className="o-grid__item">
							<CheckboxEl name="renewed_only"
								checked={ isTrue(state.renewed_only) }
								onChange={ component.handleSwitchChange }
								label="Renouvellement renseigné"
								bemit={ ['switch'] }
							/>
						</div>

						<div className="o-grid__item">
							<CheckboxEl name="renewed_budget_changed"
								checked={ isTrue(state.renewed_budget_changed) }
								onChange={ component.handleSwitchChange }
								label="Renouvellement - budget modifié"
								bemit={ ['switch'] }
							/>
						</div>

						<div className="o-grid__item u-flex u-content-end
							u-items-center u-gap-20">
							<Link href="/gestion-des-CE/nouveau-CE"
								className="c-btn c-btn--add u-no-margin-top">
								Nouveau CE
							</Link>

							<a href="/export/renouvellements-CSE"
								target="_blank" rel="noreferrer"
								className="c-btn u-no-margin-top">
								Export renouvellements
							</a>
						</div>

					</div>

					<div className="o-content">
						<Dashboard model="EnterpriseCommitee" items-per-page={ 50 }
							url="/dashboard/ECs" filters={ filters }
							header={ header } fields={ fields }
							order="ASC" order-by="company"
							disable-sort={ filters.searched ? true : false }
							component={ ECRow }
							request-update="UpdateECsDashboard"
						/>
					</div>

				</div>

			</Layout>
		);

		return output;
	}
}
